import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "marketing-event-object-status" */'marketing-event-lib/components/MarketingEventStatus').then(mod => mod.default).catch(AsyncComponentErrorHandler('marketing-event-object-status')),
  LoadingComponent: () => null
});